export const data = [
    {
        name: 'I Phone 13 pro max',
        color: ['Pacific Blue'],
        price: 1500,
        category: 'phones',
        storage: ['128GB'],
        src: 'https://images.unsplash.com/photo-1537589376225-5405c60a5bd8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGlwaG9uZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60',
    },
    {
        name: 'I Phone 12 pro max',
        color: ['Silver'],
        price: 1000,
        category: 'phones',
        storage: ['256GB'],
        src: 'https://images.unsplash.com/photo-1612100577176-b976eff1d10c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fGlwaG9uZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60',
    },
    {
        name: 'I Phone 10 pro max',
        color: ['Gold'],
        price: 1200,
        category: 'phones',
        storage: ['512GB'],
        src: 'https://images.unsplash.com/photo-1510878933023-e2e2e3942fb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzR8fGlwaG9uZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60',
    },
    {
        name: 'Samsung S22 Ultra',
        color: ['Gold'],
        price: 1100,
        category: 'phones',
        storage: ['512GB'],
        src: 'https://images.unsplash.com/photo-1637191083269-c761e7cf0798?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTDNEpUTHQoQUJMHLrErGJyHg89uy71MyuHwfHw%3D&auto=format&fit=crop&w=600&q=60',
    },
];

